import auth from 'api/auth'
import * as types from '../mutation-types'
let token = window.localStorage.getItem('accessToken')

export const userLogout = ({ commit }) => {
  window.localStorage.clear()
  const data = {}
  commit(types.USER_TOKEN, data)
  commit(types.USER_INFO, data)
  return Promise.resolve(data)
}

export const fetchAccessToken = ({ commit }, params) => {
  return auth.accessToken(params).then((data) => {
    commit(types.USER_TOKEN, data)
    return Promise.resolve(data)
  })
}

export const fetchUserInfo = ({ commit }, token) => {
  return auth.me(token).then((data) => {
    commit(types.USER_INFO, data)
    return Promise.resolve(data)
  })
}

export const fetchUserSeats = ({ commit }) => {
  return auth.meSeats(token).then((data) => {
    commit(types.USER_SEATS, data)
    return Promise.resolve(data)
  })
}

export const seatsNotification = ({ commit }) => {
  return auth.notification(token).then((data) => {
    return Promise.resolve(data)
  })
}

export const fetchRegistered = ({ commit }) => {
  return auth.meRegister(token).then((data) => {
    commit(types.USER_REGISTERES, data)
    return Promise.resolve(data)
  })
}
export const fetchPayment = ({ commit }) => {
  return auth.payment(token).then((data) => {
    commit(types.USER_PAYMENT, data)
    return Promise.resolve(data)
  })
}



// WEBPACK FOOTER //
// ./src/vuex/auth/actions.js